import { useParams } from "@tanstack/react-router";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { ChatThreadView } from "@/components/chat/ChatThreadView";
import { useChatStore } from "@/store/chat/chat.store";

/**
 * Section thread page component.
 * Displays specific thread conversation using ChatThreadView component.
 */
export default function SectionThreadPage() {
  const params = useParams({ strict: false });
  const companyId = params.company_id;
  const sectionId = params.section_id;
  const threadId = params.thread_id;

  const { openChatThreadSession, closeDashboard, activeChatThread } = useChatStore(
    useShallow((state) => ({
      openChatThreadSession: state.openChatThreadSession,
      closeDashboard: state.closeDashboard,
      activeChatThread: state.activeChatThread,
    }))
  );

  // Initialize thread context from URL parameters
  useEffect(() => {
    if (!companyId || !sectionId || !threadId) {
      return;
    }

    // Only initialize if the context doesn't match
    if (
      activeChatThread?.threadId === threadId &&
      activeChatThread?.companyId === companyId &&
      activeChatThread?.sectionId === sectionId
    ) {
      return;
    }

    closeDashboard();

    openChatThreadSession({
      threadId,
      companyId,
      sectionId,
      sectionName: "", // Will be populated if needed
      companyName: undefined, // Will be populated if needed
      title: undefined,
    });
  }, [companyId, sectionId, threadId, activeChatThread, openChatThreadSession, closeDashboard]);

  return <ChatThreadView />;
}
